/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiNurseryManagerInventoryOutCreateInventoryOutPost } from '../fn/inventory-out/api-nursery-manager-inventory-out-create-inventory-out-post';
import { ApiNurseryManagerInventoryOutCreateInventoryOutPost$Params } from '../fn/inventory-out/api-nursery-manager-inventory-out-create-inventory-out-post';
import { apiNurseryManagerInventoryOutCreateInventoryOutPost$Plain } from '../fn/inventory-out/api-nursery-manager-inventory-out-create-inventory-out-post-plain';
import { ApiNurseryManagerInventoryOutCreateInventoryOutPost$Plain$Params } from '../fn/inventory-out/api-nursery-manager-inventory-out-create-inventory-out-post-plain';
import { apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost } from '../fn/inventory-out/api-nursery-manager-inventory-out-get-inventories-details-out-post';
import { ApiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Params } from '../fn/inventory-out/api-nursery-manager-inventory-out-get-inventories-details-out-post';
import { apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Plain } from '../fn/inventory-out/api-nursery-manager-inventory-out-get-inventories-details-out-post-plain';
import { ApiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Plain$Params } from '../fn/inventory-out/api-nursery-manager-inventory-out-get-inventories-details-out-post-plain';
import { apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost } from '../fn/inventory-out/api-nursery-manager-inventory-out-get-inventories-out-by-order-details-id-post';
import { ApiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Params } from '../fn/inventory-out/api-nursery-manager-inventory-out-get-inventories-out-by-order-details-id-post';
import { apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Plain } from '../fn/inventory-out/api-nursery-manager-inventory-out-get-inventories-out-by-order-details-id-post-plain';
import { ApiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Plain$Params } from '../fn/inventory-out/api-nursery-manager-inventory-out-get-inventories-out-by-order-details-id-post-plain';
import { apiNurseryManagerInventoryOutGetInventoriesOutPost } from '../fn/inventory-out/api-nursery-manager-inventory-out-get-inventories-out-post';
import { ApiNurseryManagerInventoryOutGetInventoriesOutPost$Params } from '../fn/inventory-out/api-nursery-manager-inventory-out-get-inventories-out-post';
import { apiNurseryManagerInventoryOutGetInventoriesOutPost$Plain } from '../fn/inventory-out/api-nursery-manager-inventory-out-get-inventories-out-post-plain';
import { ApiNurseryManagerInventoryOutGetInventoriesOutPost$Plain$Params } from '../fn/inventory-out/api-nursery-manager-inventory-out-get-inventories-out-post-plain';
import { apiNurseryManagerInventoryOutGetInventoryOutPost } from '../fn/inventory-out/api-nursery-manager-inventory-out-get-inventory-out-post';
import { ApiNurseryManagerInventoryOutGetInventoryOutPost$Params } from '../fn/inventory-out/api-nursery-manager-inventory-out-get-inventory-out-post';
import { apiNurseryManagerInventoryOutGetInventoryOutPost$Plain } from '../fn/inventory-out/api-nursery-manager-inventory-out-get-inventory-out-post-plain';
import { ApiNurseryManagerInventoryOutGetInventoryOutPost$Plain$Params } from '../fn/inventory-out/api-nursery-manager-inventory-out-get-inventory-out-post-plain';
import { CreateInventoryOutCommandResult } from '../models/create-inventory-out-command-result';
import { GetInventoriesOutDetailsQueryResult } from '../models/get-inventories-out-details-query-result';
import { GetInventoriesOutQueryResult } from '../models/get-inventories-out-query-result';
import { GetInventoryOutByOrderIdQueryResult } from '../models/get-inventory-out-by-order-id-query-result';
import { GetInventoryOutQueryResult } from '../models/get-inventory-out-query-result';

@Injectable({ providedIn: 'root' })
export class InventoryOutService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiNurseryManagerInventoryOutCreateInventoryOutPost()` */
  static readonly ApiNurseryManagerInventoryOutCreateInventoryOutPostPath = '/api/NurseryManager/InventoryOut/CreateInventoryOut';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryOutCreateInventoryOutPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryOutCreateInventoryOutPost$Plain$Response(params?: ApiNurseryManagerInventoryOutCreateInventoryOutPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateInventoryOutCommandResult>> {
    return apiNurseryManagerInventoryOutCreateInventoryOutPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryOutCreateInventoryOutPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryOutCreateInventoryOutPost$Plain(params?: ApiNurseryManagerInventoryOutCreateInventoryOutPost$Plain$Params, context?: HttpContext): Observable<CreateInventoryOutCommandResult> {
    return this.apiNurseryManagerInventoryOutCreateInventoryOutPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateInventoryOutCommandResult>): CreateInventoryOutCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryOutCreateInventoryOutPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryOutCreateInventoryOutPost$Response(params?: ApiNurseryManagerInventoryOutCreateInventoryOutPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateInventoryOutCommandResult>> {
    return apiNurseryManagerInventoryOutCreateInventoryOutPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryOutCreateInventoryOutPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryOutCreateInventoryOutPost(params?: ApiNurseryManagerInventoryOutCreateInventoryOutPost$Params, context?: HttpContext): Observable<CreateInventoryOutCommandResult> {
    return this.apiNurseryManagerInventoryOutCreateInventoryOutPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateInventoryOutCommandResult>): CreateInventoryOutCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerInventoryOutGetInventoryOutPost()` */
  static readonly ApiNurseryManagerInventoryOutGetInventoryOutPostPath = '/api/NurseryManager/InventoryOut/GetInventoryOut';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryOutGetInventoryOutPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryOutGetInventoryOutPost$Plain$Response(params?: ApiNurseryManagerInventoryOutGetInventoryOutPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryOutQueryResult>> {
    return apiNurseryManagerInventoryOutGetInventoryOutPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryOutGetInventoryOutPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryOutGetInventoryOutPost$Plain(params?: ApiNurseryManagerInventoryOutGetInventoryOutPost$Plain$Params, context?: HttpContext): Observable<GetInventoryOutQueryResult> {
    return this.apiNurseryManagerInventoryOutGetInventoryOutPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoryOutQueryResult>): GetInventoryOutQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryOutGetInventoryOutPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryOutGetInventoryOutPost$Response(params?: ApiNurseryManagerInventoryOutGetInventoryOutPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryOutQueryResult>> {
    return apiNurseryManagerInventoryOutGetInventoryOutPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryOutGetInventoryOutPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryOutGetInventoryOutPost(params?: ApiNurseryManagerInventoryOutGetInventoryOutPost$Params, context?: HttpContext): Observable<GetInventoryOutQueryResult> {
    return this.apiNurseryManagerInventoryOutGetInventoryOutPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoryOutQueryResult>): GetInventoryOutQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerInventoryOutGetInventoriesOutPost()` */
  static readonly ApiNurseryManagerInventoryOutGetInventoriesOutPostPath = '/api/NurseryManager/InventoryOut/GetInventoriesOut';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryOutGetInventoriesOutPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryOutGetInventoriesOutPost$Plain$Response(params?: ApiNurseryManagerInventoryOutGetInventoriesOutPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoriesOutQueryResult>> {
    return apiNurseryManagerInventoryOutGetInventoriesOutPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryOutGetInventoriesOutPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryOutGetInventoriesOutPost$Plain(params?: ApiNurseryManagerInventoryOutGetInventoriesOutPost$Plain$Params, context?: HttpContext): Observable<GetInventoriesOutQueryResult> {
    return this.apiNurseryManagerInventoryOutGetInventoriesOutPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoriesOutQueryResult>): GetInventoriesOutQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryOutGetInventoriesOutPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryOutGetInventoriesOutPost$Response(params?: ApiNurseryManagerInventoryOutGetInventoriesOutPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoriesOutQueryResult>> {
    return apiNurseryManagerInventoryOutGetInventoriesOutPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryOutGetInventoriesOutPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryOutGetInventoriesOutPost(params?: ApiNurseryManagerInventoryOutGetInventoriesOutPost$Params, context?: HttpContext): Observable<GetInventoriesOutQueryResult> {
    return this.apiNurseryManagerInventoryOutGetInventoriesOutPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoriesOutQueryResult>): GetInventoriesOutQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost()` */
  static readonly ApiNurseryManagerInventoryOutGetInventoriesDetailsOutPostPath = '/api/NurseryManager/InventoryOut/GetInventoriesDetailsOut';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Plain$Response(params?: ApiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoriesOutDetailsQueryResult>> {
    return apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Plain(params?: ApiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Plain$Params, context?: HttpContext): Observable<GetInventoriesOutDetailsQueryResult> {
    return this.apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoriesOutDetailsQueryResult>): GetInventoriesOutDetailsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Response(params?: ApiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoriesOutDetailsQueryResult>> {
    return apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost(params?: ApiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Params, context?: HttpContext): Observable<GetInventoriesOutDetailsQueryResult> {
    return this.apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoriesOutDetailsQueryResult>): GetInventoriesOutDetailsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost()` */
  static readonly ApiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPostPath = '/api/NurseryManager/InventoryOut/GetInventoriesOutByOrderDetailsId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Plain$Response(params?: ApiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryOutByOrderIdQueryResult>> {
    return apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Plain(params?: ApiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Plain$Params, context?: HttpContext): Observable<GetInventoryOutByOrderIdQueryResult> {
    return this.apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoryOutByOrderIdQueryResult>): GetInventoryOutByOrderIdQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Response(params?: ApiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryOutByOrderIdQueryResult>> {
    return apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost(params?: ApiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Params, context?: HttpContext): Observable<GetInventoryOutByOrderIdQueryResult> {
    return this.apiNurseryManagerInventoryOutGetInventoriesOutByOrderDetailsIdPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoryOutByOrderIdQueryResult>): GetInventoryOutByOrderIdQueryResult => r.body)
    );
  }

}
